import { render, staticRenderFns } from "./DeletePerson.vue?vue&type=template&id=915ada40&lang=pug"
import script from "./DeletePerson.vue?vue&type=script&lang=js"
export * from "./DeletePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports